module.exports = "<div class='confirmation-number-container' *ngIf='reservation.confirmationNumber'>\n    <div class='' data-slnm-ihg='confirmationNumberSID'>\n        <span [innerText]=\"messages['confirmation.number.label']\"></span>\n        <span [innerText]=\"reservation.confirmationNumber\"></span>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/confirmation-number/confirmation-number.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/confirmation-number/confirmation-number.component.html
// module chunks = 0